import * as React from "react";
import { InventoryList } from "./inventory_listing";


export default function Inventory() {
    return (
       <InventoryList />
    )
}